const axios = require("axios");

const createCase = async (data) => {
  let caseRes;
  try {
    caseRes = await axios({
      url: "/api/backend/webapi/v2/case",
      method: "POST",
      data
    });

    return caseRes;

  } catch (error) {
    return error.response.data;
  }

}

export default createCase;
